import { officialEmotes } from './official-emotes';
import { isValidFileSrc } from '../../components/utils/xss';
import { cleanLinkSrc } from '../../components/utils/browser';

import { sanitizeHref } from "@wix/da-url";

import s from './viewer.scss';

const Viewer = props => {
  const HTMLAttributes = props.node.attrs;

  if (HTMLAttributes['data-type'] === 'official') {
    const emote =
      officialEmotes[HTMLAttributes['data-emote']] ??
      officialEmotes[':deviantart:'];

    return (
      <img
        loading="lazy"
        src={`https://e.deviantart.net/emoticons${emote.src}`}
        alt={emote.name}
        width={emote.width}
        height={emote.height}
        data-emote={HTMLAttributes['data-emote']}
        className={s['emote']}
        data-type={'official'}
      />
    );
  }

  if (HTMLAttributes['data-type'] === 'community') {
    return (
      <a
        data-url={cleanLinkSrc(HTMLAttributes.url)}
        data-src={cleanLinkSrc(
          isValidFileSrc(HTMLAttributes.src) ? HTMLAttributes.src : ''
        )}
        data-emote={'-community-'}
        data-type={'community'}
        data-width={HTMLAttributes.width}
        data-height={HTMLAttributes.height}
        data-title={HTMLAttributes.title}
        href={sanitizeHref(cleanLinkSrc(HTMLAttributes.url))}
      >
        <img
          loading="lazy"
          src={isValidFileSrc(HTMLAttributes.src) ? HTMLAttributes.src : ''}
          width={Math.min(parseInt(HTMLAttributes.width), 500)}
          height={Math.min(parseInt(HTMLAttributes.height), 500)}
          alt={HTMLAttributes.title}
          data-url={cleanLinkSrc(HTMLAttributes.url)}
          className={s['emote']}
          data-emote={'-community-'}
          data-type={'community'}
        />
      </a>
    );
  }

  if (HTMLAttributes['data-type'] === 'user') {
    return (
      <a
        data-url={cleanLinkSrc(HTMLAttributes.url)}
        data-src={cleanLinkSrc(
          isValidFileSrc(HTMLAttributes.src) ? HTMLAttributes.src : ''
        )}
        data-emote={'-user-'}
        data-type={'user'}
        data-width={HTMLAttributes.width}
        data-height={HTMLAttributes.height}
        data-title={HTMLAttributes.title}
        href={sanitizeHref(cleanLinkSrc(HTMLAttributes.url))}
      >
        <img
          loading="lazy"
          src={
            /^https:\/\/a\.deviantart\.net\/avatars/.test(HTMLAttributes.src)
              ? HTMLAttributes.src
              : ''
          }
          width={Math.min(parseInt(HTMLAttributes.width), 500)}
          height={Math.min(parseInt(HTMLAttributes.height), 500)}
          alt={HTMLAttributes.title}
          data-url={cleanLinkSrc(HTMLAttributes.url)}
          className={s['emote']}
          data-emote={'-user-'}
          data-type={'user'}
        />
      </a>
    );
  }

  return <></>;
};

export default Viewer;
